import './tagscloud.css';
import React from 'react';

export default class Tagscloud extends React.Component {
    render() {
        return (
            <div className='tagscloud'>
                <div className='container'>
                    <div className='tagscloud_blocks'>
                        <div className='tagscloud_block'>
                            <span className='tagscloud_item--1'>IT Security</span>
                            <span className='tagscloud_item--2'>Kubernetes and operators</span>
                            <span className='tagscloud_item--3'>Infrastructure automation</span>
                            <span className='tagscloud_item--4'>Team Effectiveness</span>
                        </div>
                        <div className='tagscloud_block'>
                            <span className='tagscloud_item--5'>Open source</span>
                            <span className='tagscloud_item--6'>Cloud</span>
                            <span className='tagscloud_item--7'>Hybrid architecture</span>
                            <span className='tagscloud_item--8'>GitOps</span>
                            <span className='tagscloud_item--9'>Agile</span>
                            <span className='tagscloud_item--10'>DevSecOps</span>
                        </div>
                        <div className='tagscloud_block tagscloud_block--left'>
                            <span className='tagscloud_item--11'>Team Development</span>
                            <span className='tagscloud_item--12'>QAOps</span>
                            <span className='tagscloud_item--13'>Distributed architecture</span>
                        </div>
                        <div className='tagscloud_block'>
                            <span className='tagscloud_item--14'>Architectural Patterns</span>
                            <span className='tagscloud_item--15'>Team Effectiveness</span>
                            <span className='tagscloud_item--16'>Delivery</span>
                            <span className='tagscloud_item--17'>Monitoring</span>
                            <span className='tagscloud_item--18'>Mindset</span>
                        </div>
                        <div className='tagscloud_block tagscloud_block--left'>
                            <span className='tagscloud_item--19'>Infrastructure-as-Code</span>
                            <span className='tagscloud_item--20'>DataOps</span>
                            <span className='tagscloud_item--21'>Standardized tooling</span>
                            <span className='tagscloud_item--22'>Continuous Integration</span>
                        </div>
                        <div className='tagscloud_block'>
                            <span className='tagscloud_item--23'>GitHub actions</span>
                            <span className='tagscloud_item--24'>Azure Bicep</span>
                            <span className='tagscloud_item--25'>Serverless computing</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}